import { Trophy } from 'lucide-react';
import { FaCertificate } from 'react-icons/fa';  // This is from Font Awesome icons

export const defaultProfile = {
  name: 'Utkarsh Patrikar',
  title: 'Devops Engineer',
  company: 'Amazon',
  location: 'Hyderabad, India',
  college: 'Ramdeobaba College of Engineering and Management',
  batch: '2027',
  department: '',  // Will be populated from signup
  about: 'Passionate software engineer with expertise in web development and cloud technologies.',
  photo: '/android-chrome-512x512.png',
  skills: [
    { name: 'React', level: 90, endorsements: 24 },
    { name: 'JavaScript', level: 85, endorsements: 18 },
    { name: 'Node.js', level: 75, endorsements: 15 },
    { name: 'AWS', level: 80, endorsements: 12 },
    { name: 'Html'},
    { name: 'Css'},
    { name: 'Figma'}
  ],
  achievements: [
    { 
      id: 1,
      title: 'Tech Lead of the Year',
      issuer: 'TCS',
      date: '2024',
      icon: Trophy
    },
    {
      id: 2,
      title: 'AWS Certified Solutions Architect',
      issuer: 'Amazon',
      date: '2023',
      icon: FaCertificate  // Changed from Certificate to FaCertificate
    }
  ],
  timeline: [
    {
      id: 1,
      role: 'Senior Software Engineer',
      company: 'Amazon',
      period: '2023 - Present',
      description: 'Leading development of enterprise applications',
      achievements: [
        'Led team of 5 developers',
        'Reduced deployment time by 50%',
        'Implemented CI/CD pipeline'
      ],
      isMilestone: true
    },
    {
      id: 2,
      role: 'Software Engineer',
      company: 'StartUp Inc',
      period: '2021 - 2023',
      description: 'Full-stack development with React and Node.js',
      achievements: [
        'Developed user authentication system',
        'Improved app performance by 40%'
      ],
      isMilestone: false
    }
  ]
};

// Add a function to merge default profile with user data
export const mergeWithDefaultProfile = (userData) => {
  return {
    ...defaultProfile,
    ...userData
  };
};
